import { render, staticRenderFns } from "./bloodFooter.vue?vue&type=template&id=02fe25fa&"
import script from "./bloodFooter.vue?vue&type=script&lang=js&"
export * from "./bloodFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports